/**
 * Created by Jerker Nord on 2023-10-16.
 */
import {LonerBuilding} from "./LonerBuilding";

export class LonerSchoolBuilding extends LonerBuilding{

    constructor() {
      super();
    }

    public init(building: string, fireAnimation: string): void {
        super.init(building, fireAnimation);
        this._fireAnimation.scale.set(0.8, 0.8);
        this._fireAnimation.position.y = (this._buildingSprite.height / 2) - (this._fireAnimation.height / 2);
    }

    public playFireAnimation(): void {
        this._fireAnimation.visible = true;
        this._buildingSprite.visible = false;
        this._crater.visible = true;
    }
}